import { render, staticRenderFns } from "./Inscricoes.vue?vue&type=template&id=66164a1d&scoped=true&lang=pug&"
import script from "./Inscricoes.vue?vue&type=script&lang=js&"
export * from "./Inscricoes.vue?vue&type=script&lang=js&"
import style0 from "./Inscricoes.vue?vue&type=style&index=0&id=66164a1d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66164a1d",
  null
  
)

export default component.exports